module.exports = __webpack_public_path__ + "static/img/JE.9dc9ba70.svg";